export const route = [
{lat:43.33675,lng:20.060865},
{lat:43.33675,lng:20.060853},
{lat:43.33675,lng:20.060853},
{lat:43.33675,lng:20.060853},
{lat:43.33675,lng:20.060853},
{lat:43.33675,lng:20.060853},
{lat:43.33675,lng:20.060853},
{lat:43.33675,lng:20.060853},
{lat:43.336765,lng:20.060848},
{lat:43.336765,lng:20.060848},
{lat:43.336765,lng:20.060848},
{lat:43.336765,lng:20.060848},
{lat:43.336765,lng:20.060848},
{lat:43.336753,lng:20.060832},
{lat:43.336757,lng:20.060834},
{lat:43.336757,lng:20.060834},
{lat:43.336757,lng:20.060834},
{lat:43.336765,lng:20.060934},
{lat:43.336612,lng:20.060943},
{lat:43.336589,lng:20.061052},
{lat:43.336605,lng:20.061424},
{lat:43.336555,lng:20.061527},
{lat:43.336502,lng:20.061687},
{lat:43.336513,lng:20.061756},
{lat:43.336509,lng:20.061866},
{lat:43.336456,lng:20.062009},
{lat:43.336418,lng:20.062103},
{lat:43.336181,lng:20.062604},
{lat:43.335983,lng:20.062889},
{lat:43.335773,lng:20.063282},
{lat:43.335632,lng:20.063634},
{lat:43.335521,lng:20.063856},
{lat:43.335468,lng:20.063945},
{lat:43.335487,lng:20.064075},
{lat:43.335529,lng:20.064058},
{lat:43.335548,lng:20.064085},
{lat:43.335197,lng:20.064079},
{lat:43.335178,lng:20.06409},
{lat:43.335113,lng:20.064113},
{lat:43.334533,lng:20.063217},
{lat:43.334503,lng:20.062801},
{lat:43.334354,lng:20.062644},
{lat:43.334201,lng:20.062601},
{lat:43.334194,lng:20.062479},
{lat:43.33448,lng:20.06244},
{lat:43.334571,lng:20.062582},
{lat:43.334571,lng:20.062528},
{lat:43.334518,lng:20.062459},
{lat:43.3344,lng:20.062509},
{lat:43.334297,lng:20.062599},
{lat:43.333946,lng:20.062578},
{lat:43.33358,lng:20.062654},
{lat:43.333301,lng:20.062824},
{lat:43.333217,lng:20.062885},
{lat:43.332965,lng:20.063329},
{lat:43.332691,lng:20.064039},
{lat:43.332736,lng:20.064167},
{lat:43.332859,lng:20.064525},
{lat:43.333011,lng:20.064088},
{lat:43.333061,lng:20.063938},
{lat:43.333068,lng:20.063655},
{lat:43.333015,lng:20.06355},
{lat:43.332874,lng:20.063297},
{lat:43.332931,lng:20.062936},
{lat:43.332839,lng:20.062696},
{lat:43.332469,lng:20.062419},
{lat:43.33245,lng:20.062423},
{lat:43.33245,lng:20.062513},
{lat:43.332561,lng:20.06249},
{lat:43.332595,lng:20.062358},
{lat:43.332855,lng:20.061954},
{lat:43.332893,lng:20.061895},
{lat:43.332965,lng:20.061901},
{lat:43.333057,lng:20.062009},
{lat:43.333141,lng:20.06199},
{lat:43.333248,lng:20.061908},
{lat:43.333259,lng:20.061832},
{lat:43.333473,lng:20.061218},
{lat:43.333572,lng:20.061048},
{lat:43.333911,lng:20.060884},
{lat:43.333908,lng:20.060886},
{lat:43.333705,lng:20.060724},
{lat:43.333656,lng:20.060518},
{lat:43.333259,lng:20.060485},
{lat:43.333068,lng:20.060623},
{lat:43.332534,lng:20.060811},
{lat:43.332374,lng:20.060884},
{lat:43.332073,lng:20.06097},
{lat:43.332046,lng:20.060976},
{lat:43.332035,lng:20.061029},
{lat:43.331989,lng:20.061214},
{lat:43.331943,lng:20.061326},
{lat:43.331817,lng:20.061515},
{lat:43.331768,lng:20.061582},
{lat:43.331462,lng:20.06174},
{lat:43.331394,lng:20.061899},
{lat:43.331272,lng:20.062202},
{lat:43.331321,lng:20.06236},
{lat:43.33139,lng:20.062465},
{lat:43.331588,lng:20.06282},
{lat:43.331607,lng:20.062864},
{lat:43.331726,lng:20.062923},
{lat:43.332019,lng:20.063295},
{lat:43.332275,lng:20.063678},
{lat:43.332496,lng:20.06385},
{lat:43.332836,lng:20.063899},
{lat:43.332893,lng:20.063894},
{lat:43.333709,lng:20.063629},
{lat:43.333816,lng:20.063564},
{lat:43.334735,lng:20.063301},
{lat:43.33506,lng:20.063081},
{lat:43.335124,lng:20.062906},
{lat:43.335124,lng:20.062643},
{lat:43.335239,lng:20.062498},
{lat:43.335376,lng:20.062261},
{lat:43.335414,lng:20.062129},
{lat:43.335483,lng:20.061975},
{lat:43.335582,lng:20.061597},
{lat:43.335678,lng:20.061355},
{lat:43.335514,lng:20.060743},
{lat:43.335407,lng:20.060491},
{lat:43.335384,lng:20.059186},
{lat:43.335357,lng:20.059158},
{lat:43.334888,lng:20.058572},
{lat:43.334896,lng:20.058502},
{lat:43.334743,lng:20.0582},
{lat:43.334758,lng:20.058202},
{lat:43.334674,lng:20.057958},
{lat:43.334484,lng:20.057849},
{lat:43.3343,lng:20.057558},
{lat:43.334362,lng:20.057695},
{lat:43.334716,lng:20.058225},
{lat:43.335163,lng:20.0589},
{lat:43.335079,lng:20.058807},
{lat:43.334831,lng:20.058797},
{lat:43.334255,lng:20.05882},
{lat:43.334007,lng:20.058757},
{lat:43.33395,lng:20.058702},
{lat:43.333881,lng:20.058727},
{lat:43.333759,lng:20.058851},
{lat:43.333675,lng:20.058847},
{lat:43.333499,lng:20.058837},
{lat:43.33337,lng:20.0589},
{lat:43.333316,lng:20.059001},
{lat:43.333145,lng:20.059164},
{lat:43.33303,lng:20.059398},
{lat:43.332931,lng:20.059404},
{lat:43.332931,lng:20.059385},
{lat:43.332748,lng:20.059219},
{lat:43.333137,lng:20.058588},
{lat:43.33316,lng:20.058593},
{lat:43.333209,lng:20.058536},
{lat:43.33329,lng:20.058452},
{lat:43.333526,lng:20.058418},
{lat:43.33356,lng:20.058612},
{lat:43.333648,lng:20.058771},
{lat:43.333694,lng:20.058847},
{lat:43.333869,lng:20.05927},
{lat:43.334056,lng:20.059421},
{lat:43.33414,lng:20.059469},
{lat:43.334278,lng:20.059608},
{lat:43.334323,lng:20.059848},
{lat:43.334251,lng:20.059932},
{lat:43.334095,lng:20.059799},
{lat:43.333831,lng:20.059574},
{lat:43.33377,lng:20.059551},
{lat:43.333919,lng:20.059675},
{lat:43.33395,lng:20.059705},
{lat:43.334186,lng:20.059928},
{lat:43.334506,lng:20.060335},
{lat:43.334808,lng:20.060762},
{lat:43.334888,lng:20.061117},
{lat:43.334915,lng:20.06118},
{lat:43.335071,lng:20.061567},
{lat:43.335453,lng:20.061872},
{lat:43.33572,lng:20.062128},
{lat:43.336547,lng:20.061021},
{lat:43.336711,lng:20.06096},
{lat:43.336715,lng:20.060945},
{lat:43.336769,lng:20.060916},
{lat:43.336856,lng:20.060987},
{lat:43.336849,lng:20.061145},
{lat:43.336986,lng:20.061248},
{lat:43.33686,lng:20.061344},
{lat:43.336868,lng:20.061361},
{lat:43.336917,lng:20.061529},
{lat:43.336856,lng:20.061595},
{lat:43.336765,lng:20.061796},
{lat:43.336738,lng:20.061851},
{lat:43.336738,lng:20.062072},
{lat:43.336849,lng:20.062097},
{lat:43.33662,lng:20.062084},
{lat:43.33657,lng:20.062269},
{lat:43.33657,lng:20.062286},
{lat:43.336639,lng:20.062385},
{lat:43.336616,lng:20.062488},
{lat:43.336547,lng:20.062665},
{lat:43.33665,lng:20.06262},
{lat:43.336685,lng:20.062589},
{lat:43.336753,lng:20.06257},
{lat:43.336513,lng:20.062789},
{lat:43.336307,lng:20.062843},
{lat:43.336215,lng:20.063083},
{lat:43.336135,lng:20.063325},
{lat:43.335983,lng:20.063537},
{lat:43.335906,lng:20.063604},
{lat:43.33588,lng:20.063819},
{lat:43.335693,lng:20.063814},
{lat:43.335453,lng:20.063695},
{lat:43.335216,lng:20.06364},
{lat:43.335147,lng:20.063655},
{lat:43.334403,lng:20.062976},
{lat:43.334381,lng:20.062915},
{lat:43.334354,lng:20.062776},
{lat:43.334133,lng:20.062585},
{lat:43.334037,lng:20.062631},
{lat:43.334014,lng:20.06278},
{lat:43.333538,lng:20.064561},
{lat:43.33366,lng:20.064804},
{lat:43.333862,lng:20.064895},
{lat:43.334041,lng:20.06492},
{lat:43.334213,lng:20.065008},
{lat:43.334426,lng:20.065023},
{lat:43.334457,lng:20.065023},
{lat:43.334861,lng:20.065069},
{lat:43.334964,lng:20.065034},
{lat:43.335151,lng:20.064973},
{lat:43.335269,lng:20.064964},
{lat:43.335494,lng:20.064821},
{lat:43.335758,lng:20.06446},
{lat:43.335704,lng:20.064056},
{lat:43.335548,lng:20.063867},
{lat:43.335418,lng:20.063686},
{lat:43.335464,lng:20.063453},
{lat:43.335498,lng:20.063146},
{lat:43.335239,lng:20.062858},
{lat:43.335006,lng:20.062673},
{lat:43.334869,lng:20.062458},
{lat:43.334754,lng:20.062112},
{lat:43.334743,lng:20.062099},
{lat:43.33443,lng:20.06179},
{lat:43.334346,lng:20.061723},
{lat:43.334266,lng:20.061674},
{lat:43.33411,lng:20.061334},
{lat:43.334041,lng:20.061212},
{lat:43.333869,lng:20.061014},
{lat:43.33337,lng:20.060554},
{lat:43.333057,lng:20.060562},
{lat:43.333007,lng:20.060571},
{lat:43.332836,lng:20.060615},
{lat:43.332813,lng:20.060617},
{lat:43.332187,lng:20.060857},
{lat:43.331939,lng:20.060903},
{lat:43.331825,lng:20.060909},
{lat:43.331676,lng:20.060913},
{lat:43.331729,lng:20.060905},
{lat:43.332901,lng:20.059419},
{lat:43.332923,lng:20.059305},
{lat:43.332767,lng:20.058227},
{lat:43.332706,lng:20.058279},
{lat:43.332675,lng:20.058273},
{lat:43.332595,lng:20.058412},
{lat:43.332462,lng:20.058534},
{lat:43.332271,lng:20.058774},
{lat:43.332214,lng:20.058643},
{lat:43.332221,lng:20.05858},
{lat:43.332187,lng:20.058475},
{lat:43.332088,lng:20.058052},
{lat:43.332099,lng:20.057985},
{lat:43.332298,lng:20.057798},
{lat:43.332473,lng:20.057786},
{lat:43.332572,lng:20.057817},
{lat:43.332695,lng:20.05788},
{lat:43.333717,lng:20.057929},
{lat:43.333744,lng:20.058082},
{lat:43.333671,lng:20.058399},
{lat:43.33366,lng:20.058572},
{lat:43.333774,lng:20.05871},
{lat:43.333923,lng:20.058883},
{lat:43.334114,lng:20.059406},
{lat:43.334159,lng:20.0596},
{lat:43.334095,lng:20.059713},
{lat:43.334053,lng:20.059686},
{lat:43.333995,lng:20.059627},
{lat:43.33366,lng:20.05953},
{lat:43.333473,lng:20.059602},
{lat:43.333255,lng:20.059709},
{lat:43.333236,lng:20.059705},
{lat:43.333053,lng:20.059703},
{lat:43.332939,lng:20.059753},
{lat:43.332805,lng:20.059726},
{lat:43.332214,lng:20.059429},
{lat:43.33208,lng:20.058923},
{lat:43.332099,lng:20.058631},
{lat:43.332103,lng:20.058248},
{lat:43.332065,lng:20.058004},
{lat:43.332099,lng:20.057952},
{lat:43.332225,lng:20.057748},
{lat:43.332382,lng:20.057588},
{lat:43.332672,lng:20.057355},
{lat:43.332599,lng:20.057275},
{lat:43.332576,lng:20.057266},
{lat:43.332592,lng:20.057205},
{lat:43.332801,lng:20.057088},
{lat:43.333038,lng:20.057134},
{lat:43.333129,lng:20.056922},
{lat:43.33319,lng:20.056732},
{lat:43.333065,lng:20.056524},
{lat:43.333122,lng:20.056488},
{lat:43.333271,lng:20.056509},
{lat:43.333656,lng:20.056859},
{lat:43.33377,lng:20.057188},
{lat:43.334175,lng:20.057064},
{lat:43.334194,lng:20.056529},
{lat:43.334514,lng:20.055429},
{lat:43.334625,lng:20.05541},
{lat:43.334655,lng:20.055408},
{lat:43.334827,lng:20.055303},
{lat:43.334873,lng:20.055206},
{lat:43.334873,lng:20.055189},
{lat:43.334865,lng:20.055002},
{lat:43.334953,lng:20.054908},
{lat:43.334968,lng:20.054912},
{lat:43.334964,lng:20.054767},
{lat:43.335002,lng:20.054674},
{lat:43.335006,lng:20.054561},
{lat:43.334953,lng:20.054475},
{lat:43.334991,lng:20.054401},
{lat:43.335285,lng:20.05404},
{lat:43.335475,lng:20.053812},
{lat:43.335674,lng:20.053644},
{lat:43.33609,lng:20.053459},
{lat:43.336547,lng:20.053028},
{lat:43.336597,lng:20.052904},
{lat:43.336807,lng:20.052871},
{lat:43.336818,lng:20.05273},
{lat:43.336509,lng:20.051132},
{lat:43.336471,lng:20.050706},
{lat:43.336448,lng:20.050386},
{lat:43.336273,lng:20.050031},
{lat:43.336185,lng:20.049922},
{lat:43.336204,lng:20.049877},
{lat:43.336196,lng:20.049852},
{lat:43.336185,lng:20.049774},
{lat:43.336235,lng:20.049638},
{lat:43.336376,lng:20.049558},
{lat:43.336765,lng:20.049293},
{lat:43.337028,lng:20.049015},
{lat:43.337158,lng:20.048816},
{lat:43.337364,lng:20.048458},
{lat:43.337432,lng:20.048263},
{lat:43.337356,lng:20.048252},
{lat:43.337329,lng:20.048242},
{lat:43.33765,lng:20.048078},
{lat:43.33776,lng:20.048055},
{lat:43.337963,lng:20.048023},
{lat:43.338096,lng:20.047914},
{lat:43.338161,lng:20.047922},
{lat:43.338165,lng:20.047916},
{lat:43.338127,lng:20.047901},
{lat:43.3381,lng:20.047895},
{lat:43.3381,lng:20.047895},
{lat:43.338146,lng:20.047945},
{lat:43.338211,lng:20.04795},
{lat:43.338207,lng:20.047946},
{lat:43.338268,lng:20.047975},
{lat:43.338294,lng:20.048019},
{lat:43.338317,lng:20.048143},
{lat:43.338382,lng:20.048145},
{lat:43.338432,lng:20.048105},
{lat:43.338489,lng:20.048213},
{lat:43.338542,lng:20.048334},
{lat:43.338703,lng:20.048418},
{lat:43.338748,lng:20.048402},
{lat:43.338932,lng:20.048477},
{lat:43.339054,lng:20.048503},
{lat:43.339233,lng:20.04844},
{lat:43.339416,lng:20.048637},
{lat:43.33963,lng:20.048666},
{lat:43.339694,lng:20.048768},
{lat:43.339801,lng:20.048858},
{lat:43.339866,lng:20.048978},
{lat:43.340053,lng:20.049312},
{lat:43.340187,lng:20.049526},
{lat:43.34019,lng:20.049581},
{lat:43.340152,lng:20.049894},
{lat:43.340038,lng:20.04997},
{lat:43.340026,lng:20.050134},
{lat:43.340053,lng:20.05021},
{lat:43.340034,lng:20.050388},
{lat:43.340091,lng:20.050447},
{lat:43.340156,lng:20.050477},
{lat:43.340263,lng:20.050643},
{lat:43.340145,lng:20.050991},
{lat:43.340156,lng:20.05116},
{lat:43.340198,lng:20.051185},
{lat:43.340209,lng:20.051189},
{lat:43.340263,lng:20.051324},
{lat:43.34037,lng:20.051446},
{lat:43.340328,lng:20.051517},
{lat:43.340377,lng:20.0519},
{lat:43.340499,lng:20.05203},
{lat:43.340778,lng:20.052108},
{lat:43.340892,lng:20.052009},
{lat:43.340984,lng:20.05195},
{lat:43.34098,lng:20.05183},
{lat:43.341033,lng:20.05158},
{lat:43.341083,lng:20.051401},
{lat:43.341091,lng:20.051269},
{lat:43.341133,lng:20.051019},
{lat:43.341342,lng:20.050687},
{lat:43.341411,lng:20.050594},
{lat:43.341342,lng:20.049758},
{lat:43.34122,lng:20.049839},
{lat:43.341117,lng:20.04972},
{lat:43.341133,lng:20.049472},
{lat:43.341167,lng:20.049215},
{lat:43.341266,lng:20.049213},
{lat:43.34132,lng:20.049253},
{lat:43.341445,lng:20.049255},
{lat:43.341518,lng:20.049205},
{lat:43.341587,lng:20.049118},
{lat:43.341762,lng:20.048879},
{lat:43.341873,lng:20.04873},
{lat:43.342124,lng:20.048435},
{lat:43.342281,lng:20.048309},
{lat:43.342437,lng:20.048046},
{lat:43.342609,lng:20.047809},
{lat:43.342838,lng:20.047655},
{lat:43.342853,lng:20.047658},
{lat:43.343074,lng:20.04778},
{lat:43.343059,lng:20.047903},
{lat:43.342948,lng:20.048034},
{lat:43.342845,lng:20.048145},
{lat:43.342708,lng:20.048273},
{lat:43.342628,lng:20.048282},
{lat:43.342613,lng:20.04824},
{lat:43.342544,lng:20.048009},
{lat:43.342254,lng:20.04776},
{lat:43.342189,lng:20.0477},
{lat:43.342121,lng:20.047502},
{lat:43.342029,lng:20.047409},
{lat:43.341831,lng:20.047512},
{lat:43.341831,lng:20.047708},
{lat:43.341808,lng:20.047986},
{lat:43.341827,lng:20.047969},
{lat:43.341938,lng:20.047779},
{lat:43.342117,lng:20.047681},
{lat:43.342353,lng:20.047416},
{lat:43.342502,lng:20.047399},
{lat:43.342552,lng:20.04743},
{lat:43.342575,lng:20.047464},
{lat:43.342586,lng:20.047412},
{lat:43.342597,lng:20.047218},
{lat:43.342555,lng:20.047183},
{lat:43.342391,lng:20.047285},
{lat:43.34243,lng:20.047231},
{lat:43.342376,lng:20.04733},
{lat:43.342216,lng:20.04799},
{lat:43.342082,lng:20.048274},
{lat:43.342006,lng:20.048419},
{lat:43.341728,lng:20.048751},
{lat:43.34148,lng:20.048994},
{lat:43.341281,lng:20.049039},
{lat:43.341011,lng:20.049121},
{lat:43.340858,lng:20.049053},
{lat:43.340694,lng:20.049146},
{lat:43.340583,lng:20.049398},
{lat:43.340698,lng:20.049774},
{lat:43.340682,lng:20.04989},
{lat:43.340888,lng:20.050239},
{lat:43.340957,lng:20.050399},
{lat:43.340995,lng:20.050735},
{lat:43.341197,lng:20.051002},
{lat:43.341232,lng:20.051059},
{lat:43.341304,lng:20.051103},
{lat:43.341674,lng:20.051338},
{lat:43.341926,lng:20.051107},
{lat:43.342044,lng:20.050649},
{lat:43.342079,lng:20.050598},
{lat:43.342105,lng:20.050342},
{lat:43.342159,lng:20.050161},
{lat:43.342132,lng:20.050083},
{lat:43.34206,lng:20.04985},
{lat:43.342163,lng:20.049669},
{lat:43.342216,lng:20.049497},
{lat:43.342193,lng:20.049289},
{lat:43.342132,lng:20.049093},
{lat:43.342056,lng:20.048917},
{lat:43.34193,lng:20.048889},
{lat:43.341621,lng:20.048923},
{lat:43.341476,lng:20.048913},
{lat:43.341224,lng:20.048667},
{lat:43.340911,lng:20.048702},
{lat:43.340877,lng:20.048666},
{lat:43.340831,lng:20.048564}
];